import { campaignController, UseCase } from '../core';
import { convertTimeWithTimezone } from '@/utils/time';

export const getRcsFallbackCampaignSuggestions = async (
  params: {
    campaignUidPrefix: string;
    brandUid: string;
    limit?: number;
  },
  tenDlcUseCases: UseCase[] = []
) => {
  const suggestions = await campaignController.getCampaignSuggestions(
    {
      status: 'ACTIVE',
      channelId: '10DLC',
      limit: 20,
      fallbackAssociation: false,
      ...params,
    },
    { silent: true }
  );

  const useCaseMap = new Map(
    tenDlcUseCases?.map((useCase) => [useCase.id, useCase.displayName])
  );

  return suggestions.map(({ campaignUid, usecase, registeredDate }) => ({
    label: `${campaignUid} (${
      useCaseMap.get(usecase) || usecase
    }) ${convertTimeWithTimezone(registeredDate, undefined, 'MM/DD/YYYY')}`,
    value: campaignUid,
  }));
};
